import {Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {NaviosViagensModel} from "./navios-viagens.model";
import {NaviosViagensService} from './navios-viagens.service';
import {Funcoes} from "../funcoes";
import {PortosService} from "../portos/portos.service";
import {NaviosService} from "../navios/navios.service";
import {LoginService} from "../login/login.service";
import {Global} from "../global";

declare var $:any;

@Component({
  selector: 'app-navios-viagens-form',
  templateUrl: './navios-viagens-form.component.html'
})
export class NaviosViagensFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  viagem: NaviosViagensModel = new NaviosViagensModel();
  listNavios = [];
  listPortos = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private naviosViagensService: NaviosViagensService,
    private portosService: PortosService,
    private naviosService: NaviosService,
    private loginService: LoginService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      id_navio: ['', [
        Validators.required
      ]],
      id_porto_carregamento: [],
      id_porto_descarga: [],
      enviado_bordo: [],
      eta: [],
      data_descarga: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_viagem'];

      if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarViagemNavio');
      }else if(this.pageIsAdd){
        this.title = this.func.traduzir('front.cadastrarViagemNavio');
        this.viagem.id_navio = params['id_navio'];
      }else{
        this.title = this.func.traduzir('front.visualizarViagemNavio')
      }

      this.portosService.get()
        .subscribe(
          json => {
            this.listPortos = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.naviosService.get()
        .subscribe(
          json => {
            this.listNavios = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        // inicializa pick a date em timeout para nao bugar
        let self = this;
        setTimeout(function () {
          $('.pickadate').pickadate({
            format: 'dd/mm/yyyy',
            formatSubmit: 'yyyy-mm-dd',
            onSet: function(context) {
              self.viagem[this.get('id')] = this._hidden.value;
            }
          });
        },100);

        // cancela carregamento para edição
        return;
      }

      this.naviosViagensService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            this.viagem = json.Payload[0];

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarViagemNavio')+': '+json.Payload[0].id;
            }else if(this.pageIsAdd){
              this.title = this.func.traduzir('front.cadastrarViagemNavio');
            }else{
              this.title = this.func.traduzir('front.visualizarViagemNavio') + ': ' + json.Payload[0].id;
            }

            // inicializa pick a date em timeout para nao bugar
            this.loginService.getUserInfo()
              .subscribe(
                res => {
                  let self = this;
                  setTimeout(function () {
                    $('.pickadate').pickadate({
                      format: res.date_format,
                      formatSubmit: 'yyyy-mm-dd',
                      onSet: function(context) {
                        self.viagem[this.get('id')] = this._hidden.value;
                      }
                    });
                  },100);
                },
                error => {
                  this.func.showErro(error.json());
                });

          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.naviosViagensService.editar(values, values.id);
    } else {
      result = this.naviosViagensService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'navios', values.id_navio]),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/navios-viagens/navios-viagens-form.component.ts